import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import { Col, Container, Row } from 'react-bootstrap';
import DetailField from './detail-field';
import PpcUserForm from './ppc-user-form';
import BackLink from '../../../common/back-link/index';
import PageTitle from '../../../common/page-title/index';
import ArrowButton from '../../../common/button-arrow';
import IgniteDataTable from '../../../common/datatable/index';
import ConfirmPopup from '../../../common/confirm-popup';
import { dateFormatUK } from '../../../../utils/commonFunctions';
import { cancelPpcUserLoad, getPpcUser, getPpcUserLoads } from '../../../../actions/ppc';
import { history } from '../../../../store';

import './styles.css';
import t from '../../../../data/translations';

class PpcUser extends Component {
  handlePageChange = (page) => {
    this.props.dispatch(getPpcUserLoads(this.id, page));
    this.setState({pageNumber: page});
  };

  handleManualCardLoad = () => {
    history.push(`/admin/ppc/management/${this.id}/loads/new`);
  };

  handleCancel = (result) => {
    const { id } = this.state.delete;

    this.setState({delete: {show: false}});

    if (result) {
      this.props.dispatch(cancelPpcUserLoad(this.props.user.id, id));
    }
  };

  constructor(props) {
    super(props);

    this.state = {
      pageNumber: 1,
      delete: {
        show: false
      }
    };

    this.columns = [
      {
        prop: 'created-at',
        title: 'Load date',
        format(data) {
          return dateFormatUK(data);
        }
      },
      {
        prop: 'points',
        title: 'Value (points)',
        width: '120'
      },
      {
        prop: 'value',
        title: `Value (${t('currency')})`,
        width: '100'
      },
      {
        prop: 'load-type',
        title: 'Load type',
        width: '150'
      },
      {
        prop: 'status',
        title: 'Status',
        width: '150'
      },
    ];

    this.actions = [
      {
        label: 'Edit',
        disabled: row => row.attributes.status !== 'unprocessed',
        permissions: {
          action: 'manage',
          subjectClass: 'PpcUser',
        },
        callback: (row) => {
          history.push(`/admin/ppc/management/${this.id}/loads/${row.id}`);
        }
      },
      {
        label: 'Cancel',
        disabled: row => row.attributes.status !== 'unprocessed',
        permissions: {
          action: 'manage',
          subjectClass: 'PpcUser',
        },
        callback: (row) => {
          this.setState({
            delete: {
              show: true,
              id: row.id
            }
          });
        }
      }
    ];
  }

  UNSAFE_componentWillMount() {
    this.id = +this.props.match.params.id;
    this.props.dispatch(getPpcUser(this.id));
    this.props.dispatch(getPpcUserLoads(this.id));
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.admin_ppc.management.user'));
    this.props.dispatch({type: 'CLEAR_EDIT_PPC_USER'});
  }

  render() {
    const { pagination, loads } = this.props;

    return (
      <Container fluid className="ppc-user">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/ppc/management"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="header">
              <PageTitle>
                {this.props.user ? (`${this.props.user.attributes['first-name']} ${this.props.user.attributes['last-name']}`) : '...'}
              </PageTitle>
              <ArrowButton
                arrow={false}
                className="float-end"
                onClick={this.handleManualCardLoad}
                permissions={{
                  action: 'manual-load',
                  subjectClass: 'PpcUser',
                }}
                submit={false}
              >
                Manual prepaid card load
              </ArrowButton>
            </div>
          </Col>
        </Row>
        <Row className="loads-table">
          <Col lg={12}>
            <IgniteDataTable
              actions={this.actions}
              columns={this.columns}
              data={loads}
              hideId={false}
              dataSize={pagination ? pagination.number * pagination.size : loads.length}
              pagination={{
                page: this.state.pageNumber,
                sizePerPage: 10,
                onPageChange: this.handlePageChange
              }}
              remote
            />

            {
              this.state.delete.show && (
                <ConfirmPopup
                  header="CANCEL PREPAID CARD LOAD"
                  onClose={this.handleCancel}
                >
                  <p>
                    Are you sure you want to cancel this PPC load?
                  </p>
                </ConfirmPopup>
              )}
          </Col>
        </Row>
        <div className="user-details">
          <DetailField label="User ID">
            {this.props.user && this.props.user.id}
          </DetailField>
          <DetailField label="PPC account number">
            {this.props.user && this.props.user.attributes['account-number']}
          </DetailField>
          <DetailField label="Opt in date">
            {this.props.user && dateFormatUK(this.props.user.attributes['created-at'])}
          </DetailField>
        </div>
        {
          this.props.user && <PpcUserForm id={this.id} statuses={this.props.statuses}/>
        }
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  user: state.ppc.user,
  statuses: state.ppc.kycStatuses,
  loads: state.ppc.loads.list,
  pagination: state.ppc.loads.paging,
  fetched: state.ppc.fetched,
  fetching: state.ppc.fetching,
});

export default connect(mapStateToProps)(PpcUser);
